import { HandPlatter, Smartphone } from "lucide-react";
import React from "react";

import Avatar from "../cardapio-mesa/Avatar";

// Chave do produto na conta (a mesma do Fechar mesa e do servidor):
// cartItemId, ou "i<posição sem os riscados>" no produto antigo sem id
export const chaveDoItem = (item, posicao) => String(item.cartItemId ?? `i${item._idx ?? posicao}`);

/**
 * De quem é o produto e quem o mandou para a cozinha. `pessoas` e `donos`
 * vêm de GET /mesa-qr/{mesa}/pessoas (usePessoasMesa): o dono do item antigo
 * do QR, sem `_cliente_id`, está no pedido da rodada — o servidor resolve.
 */
export function quemPediu(item, { pessoas = [], donos = {} } = {}, posicao) {
  const clienteId = item._cliente_id || donos[chaveDoItem(item, posicao)] || null;
  const pessoa = clienteId ? pessoas.find((p) => p.cliente_id === clienteId) : null;
  const doQr = item._origem === "qr" || !!item._qid;
  return {
    temGente: pessoas.length > 0,
    nome: pessoa?.primeiro_nome || pessoa?.nome || item._cliente_nome || (doQr ? item._por : null) || null,
    foto: pessoa?.foto || null,
    semDono: !clienteId,
    doQr,
    lancadoPor: item._lancado_por || null,
  };
}

// Linha embaixo do produto (dono, 24/09/2026): o rosto e o nome de quem vai
// pagar (ou "Mesa") e como o produto chegou — pelo celular, ou "lançado por
// João" quando veio do painel. Igual à comanda do celular, mas por produto.
export default function QuemPediu({ info, fotoDe, className = "" }) {
  if (!info) return null;
  const { temGente, nome, foto, semDono, doQr, lancadoPor } = info;
  const mostraDono = temGente || doQr || !!nome;
  if (!mostraDono && !lancadoPor) return null;
  return (
    <div className={`flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] leading-none ${className}`} data-e2e="quem-pediu">
      {mostraDono ? (
        <span className="inline-flex items-center gap-1 font-semibold min-w-0">
          <Avatar nome={nome || "Mesa"} foto={foto} fotoDe={fotoDe} tamanho={18} balcao={semDono && !nome} />
          <span className="truncate max-w-[9rem]">{semDono && !nome ? "Mesa" : nome}</span>
        </span>
      ) : null}
      {doQr ? (
        <span className="inline-flex items-center gap-0.5 text-sky-600 dark:text-sky-400">
          <Smartphone className="w-3 h-3" /> pelo celular
        </span>
      ) : lancadoPor ? (
        <span className="inline-flex items-center gap-1 text-violet-600 dark:text-violet-400" data-e2e="lancado-por">
          <HandPlatter className="w-3 h-3" /> lançado por
          {lancadoPor.foto ? <Avatar nome={lancadoPor.nome} foto={lancadoPor.foto} fotoDe={fotoDe} tamanho={16} /> : null}
          <span className="font-semibold">{lancadoPor.nome || "Equipe"}</span>
        </span>
      ) : null}
    </div>
  );
}
